// 9fbef606107a605d69c0edbcd8029e5d
import isEmpty from 'lodash/isEmpty';
import styled from 'styled-components';
import Image from '@tcp/core/src/components/common/atoms/Image';
import Button from '@tcp/core/src/components/common/atoms/Button';
import TextBox from '@tcp/core/src/components/common/atoms/TextBox';

export const Container = styled.div`
  border: 1px solid ${(props) => props.theme.colorPalette.gray[3300]};
  padding: 18px 10px;
  @media ${(props) => props.theme.mediaQuery.large} {
    padding: 24px;
    margin: 0 32px;
  }
`;

export const Row = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;

  @media ${(props) => props.theme.mediaQuery.xlarge} {
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 10px;
  }
`;

export const DisclaimerRow = styled.div`
  display: flex;
  padding-top: 16px;

  @media ${(props) => props.theme.mediaQuery.xlarge} {
    padding-top: 24px;
  }
`;

export const LabelContainer = styled.div`
  text-align: center;
  margin-bottom: 8px;

  @media ${(props) => props.theme.mediaQuery.medium} {
    ${(props) => (props.isTranslatedPage ? `flex: 0 0 60%;` : `flex: 0 0 50%;`)}
  }
`;

export const HeadingRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  @media ${(props) => props.theme.mediaQuery.medium} {
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 5px;
  }
`;

export const HeadingLine1 = styled.label`
  font-size: ${(props) => (props.isTranslatedPage ? `16px` : `18px`)};
  font-weight: bold;
  color: ${(props) => (!isEmpty(props.colorValue) ? `${props.colorValue.textColor}` : `#0070f3`)};
  @media ${(props) => props.theme.mediaQuery.smallMax} {
    font-size: 18px;
  }
`;

export const HeadingLine2 = styled.label`
  font-size: ${(props) => (props.isTranslatedPage ? `16px` : `18px`)};
  font-weight: bold;
  color: ${(props) => (!isEmpty(props.colorValue) ? `${props.colorValue.textColor}` : `#0070f3`)};
  @media ${(props) => props.theme.mediaQuery.smallMax} {
    font-size: 14px;
  }
`;

export const VisuallyHidden = styled.label`
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;

export const FieldWrapper = styled.div`
  @media ${(props) => props.theme.mediaQuery.medium} {
    width: 40%;
  }
  @media ${(props) => props.theme.mediaQuery.xlarge} {
    width: 60%;
  }
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;

  @media ${(props) => props.theme.mediaQuery.medium} {
    flex-direction: row;
    align-items: center;
    gap: 20px;
    justify-content: center;
  }

  @media ${(props) => props.theme.mediaQuery.large} {
    flex-direction: row;
    align-items: center;
  }
`;

export const EmailInput = styled(TextBox)`
  input.TextBox__input {
    margin: 0;
    border-radius: 6px;
    border: 1px solid #d8d8d8;
    padding-top: 12px;
    padding-bottom: 12px;
    padding-left: 16px;
    background: #fff;
    font-size: 14px;
    width: 96%;
  }

  p.TextBox__placeholder {
    display: block;
    margin-top: -10px;
    padding-left: 16px;
  }
`;

export const SubmitButton = styled(Button)`
  background-color: #000;
  color: white;
  padding: 12px;
  font-size: 14px;
  font-weight: bold;
  border: none;
  border-radius: 6px;

  @media ${(props) => props.theme.mediaQuery.medium} {
    width: 40%;
    ${(props) => (props.isSubmission ? `margin-top: -20px;` : ``)}
  }
`;

export const MessageSection = styled.div`
  padding: 0;
  padding-top: 4px;
  padding-left: 4px;
  display: flex;
  align-items: center;
`;

export const SubmissionText = styled.label`
  font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
  font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy2}px;
  font-weight: ${(props) => props.theme.fonts.fontWeight.extrabold};
  line-height: normal;
  -webkit-letter-spacing: normal;
  -moz-letter-spacing: normal;
  -ms-letter-spacing: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${(props) => (props.isSubmissionSuccess ? `#26762d` : ` #c8102e`)};
`;

export const AlertImage = styled(Image)`
  background-size: contain;
  border: none;
  height: 14px;
  width: 16px;
  margin-right: 7px;
  -webkit-flex-shrink: 0;
  -ms-flex-negative: 0;
  flex-shrink: 0;
`;
